import React from "react";

function StatusBadge({ status, tone = "default", className = "" }) {
  const classes = [
    "ui-status-badge",
    `ui-status-badge--${tone}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <span className={classes}>{status}</span>;
}

export default StatusBadge;
